var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPpt = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F2784D",
  fillRule: "evenodd",
  d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 0v4a2 2 0 0 0 2 2h4z",
  opacity: 0.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 8,
  x: 2,
  y: 13,
  fill: "#F7F8FA",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2784D",
  d: "M4.5 19v-4h1.743q.474 0 .818.176.347.174.534.486.188.31.188.723 0 .414-.192.724a1.26 1.26 0 0 1-.542.479q-.353.17-.837.17H5.137v-.762h.886a.9.9 0 0 0 .385-.076.54.54 0 0 0 .237-.213.63.63 0 0 0 .08-.322.6.6 0 0 0-.08-.32.53.53 0 0 0-.237-.212.9.9 0 0 0-.385-.074H5.52V19zM8.286 19v-4h1.743q.473 0 .818.176.346.174.534.486.187.31.187.723 0 .414-.191.724a1.26 1.26 0 0 1-.542.479q-.352.17-.837.17H8.922v-.762h.886a.9.9 0 0 0 .386-.076.54.54 0 0 0 .237-.213.63.63 0 0 0 .08-.322.6.6 0 0 0-.08-.32.53.53 0 0 0-.237-.212.9.9 0 0 0-.386-.074h-.502V19zM11.933 15.785V15H15.5v.785h-1.28V19h-1.005v-3.215z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPpt);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;